export enum PdfTemplateViewOption {
    BOOKING_RELATED,
    CONTACT_REQUEST_RELATED,
    HEADER_FOOTER,
    PRE_CONFIRMATION,
    CREATE_BOOKING_RELATED,
    CREATE_CONTACT_REQUEST_RELATED,
    EDIT_BOOKING_RELATED,
    EDIT_CONTACT_REQUEST_RELATED,
    EDIT_HEADER_FOOTER,
    EDIT_PRE_CONFIRMATION,
    FINAL_CONFIRMATIONS,
    EDIT_FINAL_CONFIRMATION,
    CONFIRMATIONS,
    EDIT_CONFIRMATION
}
